import React from 'react'
import PropTypes from 'prop-types'
import styles from './_title.css'

function Title (props) {
  const {
    children,
    align,
    color,
  } = props

  const titleStyles = {
    color: color || 'black',
  }

  const ruleStyles = {
    borderColor: color || 'black',
  }

  const alignClass = align ? `align--${align}` : 'align--left'

  return (
    <h2 className={`${styles.title} ${styles[alignClass]}`} style={titleStyles}>
      <hr className={styles.rule} style={ruleStyles} />
      {children}
      <hr className={styles.rule} style={ruleStyles} />
    </h2>
  )
}

Title.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
}

export default Title



// WEBPACK FOOTER //
// ./src/components/app-page/shared/Title/index.jsx